import { useMemo } from 'react';
import uuid from 'uuid';
import { extractBlockProps as extractCardProps } from '../../extractors/block';
import { useSmartCardActions as useLinkActions } from '../actions';
import { useSmartLinkAnalytics as useLinkAnalytics } from '../analytics';
import { useSmartCardState as useLinkState } from '../store';
import { getExtensionKey } from '../helpers';
export function useSmartLinkActions(_ref) {
  var url = _ref.url,
    appearance = _ref.appearance,
    analyticsHandler = _ref.analyticsHandler,
    _ref$platform = _ref.platform,
    platform = _ref$platform === void 0 ? 'web' : _ref$platform,
    origin = _ref.origin,
    actionOptions = _ref.actionOptions;
  var id = useMemo(function () {
    return uuid();
  }, []);
  var linkState = useLinkState(url);
  var linkAnalytics = useLinkAnalytics(url, analyticsHandler, id);
  var linkActions = useLinkActions(id, url, linkAnalytics);
  if (linkState.details && !(actionOptions !== null && actionOptions !== void 0 && actionOptions.hide)) {
    var cardProperties = extractCardProps(linkState.details.data, linkState.details.meta, {
      handleInvoke: function handleInvoke(opts) {
        return linkActions.invoke(opts, appearance);
      },
      analytics: linkAnalytics,
      origin: origin,
      extensionKey: getExtensionKey(linkState.details),
      source: appearance,
      actionOptions: actionOptions
    }, undefined, platform);
    if (cardProperties.actions && cardProperties.actions.length > 0) {
      var cardActions = cardProperties.actions.map(function (action) {
        return {
          id: action.id,
          text: action.text,
          invoke: action.promise
        };
      });
      return cardActions;
    }
  }
  return [];
}